import {camelCase, reduce, split, trim} from "lodash";
import {camelizeKeys} from "../ReduxStore/Helpers/transformObject";
import {ZINDEXES} from "../ClientOnly/constants";

export function getZIndex(name, fallback = 0) {
  name = (''+name).trim();

  return ZINDEXES[name] || fallback;
}

export function getMatchingClasses(node, regex) {
  if (!node?.classList)
    return [];

  return Array.from(node.classList)
    .filter(klass => klass.toString().match(regex));
}

export function removeMatchingClasses(node, regex) {
  const classes = getMatchingClasses(node, regex);

  if (!_.isEmpty(classes)) {
    const classList = node.classList;
    classes.forEach( klass => classList.remove(klass));
  }

  return classes;
}

/**
 * Given a node, look for the nearest ancestor
 * @param node
 * @param klass
 * @returns {*|null}
 */
export function findNearestAncestorWithClass(node, klass, {quiet = false} = {}) {
  const result = findNearestAncestor(node, (ancestor) => {
    let classList = ancestor.classList;
    return classList?.contains && classList.contains(klass);
  })

  if (!result && !quiet)
    console.warn(`failed to find ancestor with class ${klass} for node: `, node);

  return result;
}

export function findNearestAncestor(node, fn) {
  let ancestor = node?.parentNode;
  while (ancestor) {
    if (fn(ancestor)) {
      return ancestor;
    }
    // failed, go up the chain
    ancestor = ancestor.parentNode;
  }
  return null;
}

export function findNodeOrAncestor(node, fn) {
  if (fn(node))
    return node;
  return findNearestAncestor(node, fn);
}

export function textToHtml(text) {
  const parser = new DOMParser();
  return parser.parseFromString(text, "text/html");
}

/**
 * Extract attribute names/values from a node.
 * CAUTION: DOM attribute names are always lowercase.
 *
 * @param node
 * @returns {{}}
 */
export function extractAttributes(node) {
  // avoid: attributes is not iterable (for text nodes)
  if (!node.attributes)
    return {};

  const hash = {};
  for (let attr of node.attributes) {
    hash[attr.nodeName] = attr.nodeValue;
  }
  return hash;
}

/**
 * Harvest the controller name from our body id, which is like controller-action.
 * and camelize it, just because.
 *
 * @returns {string|string}
 */
export function getControllerName() {
  let body = document.getElementsByTagName('body')[0];
  let bodyId = body?.getAttribute('id') || 'unknown';
  return camelCase(split(bodyId, '-')[0] || 'unknown');
}

export function enableScrolling(enabled = true, target= null) {
  target ||= document.getElementsByTagName('body')[0];
  if (!target?.classList) {
    console.log("enableScrolling: no target!");
    return;
  }

  if (enabled) {
    target.classList.remove('overflow-y-hidden');
    target.classList.add('overflow-y-scroll');
  } else {
    target.classList.remove('overflow-y-scroll');
    target.classList.add('overflow-y-hidden');
  }
}

export function withElement(elementOrId, callback) {
  let element = (typeof elementOrId === 'string') ?
    document.getElementById(elementOrId) : elementOrId;

  if (!element) {
    let message = `withElement ${elementOrId}: not found`;
    console.warn(message);
    return { error: true, message};
  }

  if (callback)
    return callback(element);
  else
    return element;
}

export function safeUpdateStyle(elementOrId, newStyles) {
  if (typeof newStyles === 'string')
    newStyles = parseStyleList(newStyles);

  withElement(elementOrId, e => {
    if (e && e.style) {
      Object.assign(e.style, newStyles);
    }
  })
}

// convert css style string like "border-color: red; z-index: 99" to
// properly capitalized json format like { borderColor: red, zIndex: 99 }
export function parseStyleList(styleText) {
  return reduce(styleText.toString().split(';'), (styles, term) => {
    let [k, ...rest] = term.split(':');
    styles[camelCase(k).trim()] = rest.join(':').trim();
    return styles;
  }, {});
}



// let test = parseStyleList("color: red; z-index: 38  ; border-color    :          orange ; border: 1px solid green; crap: with-a : colon : midstream");
// alert(JSON.stringify(test,null,2))

